// extracted by mini-css-extract-plugin
export default {"container":"PageEmbedBadge_container__qldpB"};